import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TransformType } from "4d-mapper";

@Component({
    selector:'[qmap-form]',
    templateUrl:'./qmap.form.html'
})
export class QMapForm{
    @Input()
    transform:TransformType

    @Input()
    model:any = {}

    @Output()
    commence = new EventEmitter<any>()
    
    @Output()
    cancel = new EventEmitter<any>()

    onSave(){
        this.commence.emit(this.model)
    }

    onCancel(){
        this.cancel.emit(this.model)
    }
}